import { CustomTableConfig } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { getBasicColumnConfig } from 'core/utils/format-table-cell';
import { formatListField } from 'core/utils/format-table-cell/format-table-cell';
import { EditableColumn } from 'modules/global/model';
import { MaterialDefinition } from 'modules/settings/pods/settings-materials/material-definition.vm';

export const useDefaultConfigMaterialDefinitionsList = () => {
    const { t } = useTranslation();

    const getHeaderColumn = (column: string) => `settings.materials.material-definitions.columns.${column}`;

    const getColumnsToShow = (): EditableColumn[] => [
        { field: 'name', text: t(getHeaderColumn('name')), visible: true, pinned: false, columnIndex: 0 },
        { field: 'longName', text: t(getHeaderColumn('long-name')), visible: true, pinned: false, columnIndex: 1 },
        { field: 'provider', text: t(getHeaderColumn('provider')), visible: true, pinned: false, columnIndex: 2 },
        { field: 'type', text: t(getHeaderColumn('type')), visible: true, pinned: false, columnIndex: 3 },
        { field: 'deviceType', text: t(getHeaderColumn('device-type')), visible: true, pinned: false, columnIndex: 4 },
        { field: 'tests', text: t(getHeaderColumn('tests')), visible: true, pinned: false, columnIndex: 5 },
    ];

    const getDefaultConfig = (): CustomTableConfig<MaterialDefinition> => ({
        entity: 'materialDefinition',
        columnsToShow: getColumnsToShow(),
        fields: [
            getBasicColumnConfig(t, getHeaderColumn, 'name', true),
            {
                name: 'longName',
                headerOptions: {
                    text: t(getHeaderColumn('long-name')),
                    sortable: true,
                },
            },
            getBasicColumnConfig(t, getHeaderColumn, 'provider', true),
            {
                name: 'type',
                headerOptions: {
                    text: t(getHeaderColumn('type')),
                    sortable: true,
                },
                rowOptions: {
                    cellOptions: {
                        format: (item: MaterialDefinition) =>
                            t(`settings.materials.material-definitions.type.${item.type}`),
                    },
                },
            },
            {
                name: 'deviceType',
                headerOptions: {
                    text: t(getHeaderColumn('device-type')),
                },
                rowOptions: {
                    cellOptions: {
                        format: (item: MaterialDefinition) => item.deviceType.name,
                    },
                },
            },
            {
                name: 'tests',
                headerOptions: {
                    text: t(getHeaderColumn('tests')),
                },
                rowOptions: {
                    cellOptions: {
                        format: (item: MaterialDefinition) =>
                            formatListField(
                                item.testConfigs.map((testConfig) => ({
                                    id: testConfig.testId,
                                    name: testConfig.testName,
                                }))
                            ),
                    },
                },
            },
        ],
    });

    return { getDefaultConfig };
};
